<template>
  <v-row no-gutters>
    <v-col
      cols="12"
      style="background-color: rgba(255, 255, 255, 0.7); border-radius: 10px; min-width: 200px"
      class="pa-2 mb-3"
    >
      <v-row no-gutters v-for="(item, idx) in computedProjectLayers" :key="idx" class="pb-2">
        <template v-if="item.layers">
          <v-col cols="12">
            <v-row no-gutters class="font-size-14 font-weight-medium group-name">
              {{ item.name }}
            </v-row>
            <v-row no-gutters v-for="(layer, idx) in item.layers" :key="idx">
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-col cols="10" class="pr-2" v-on="on">
                    <data-input
                      v-model="layer.visible"
                      v-bind="{ label: layer.name }"
                      :data-type="{ name: 'checkbox' }"
                      color="secondary"
                      hide-details
                      @change="toggleLayer(layer.id, $event)"
                    />
                  </v-col>
                </template>
                {{ layer.name }}
              </v-tooltip>
              <v-spacer />
              <v-col cols="auto" v-if="layer.style">
                <layer-style-preview-icon is-icon :layer-type="getLayerType(layer)" :layer-style="layer.style" />
              </v-col>
            </v-row>
          </v-col>
        </template>
        <template v-else>
          <v-tooltip top>
            <template #activator="{ on }">
              <v-col cols="10" class="pr-2" v-on="on">
                <data-input
                  v-model="item.visible"
                  v-bind="{ label: item.name }"
                  :data-type="{ name: 'checkbox' }"
                  color="secondary"
                  hide-details
                  @change="toggleLayer(item.id, $event)"
                />
              </v-col>
            </template>
            {{ item.name }}
          </v-tooltip>
          <v-spacer />
          <v-col cols="auto" v-if="item.style">
            <layer-style-preview-icon is-icon :layer-type="getLayerType(item)" :layer-style="item.style" />
          </v-col>
        </template>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';

import DataInput from '@/components/shared/inputs/DataInput';
import LayerStylePreviewIcon from '@/components/map/LayerStylePreviewIcon';

import stylePreviewUtility from '@/mixins/shared/stylePreviewUtility';

export default {
  name: 'TheLegend',
  components: { DataInput, LayerStylePreviewIcon },
  mixins: [stylePreviewUtility],
  data: () => ({
    investedAvailable: false,
    investedAreas: false,
  }),
  computed: {
    projects: get('featuresData/projects'),
    currentLng() {
      return this.$i18n.locale;
    },
    project() {
      return this.projects[this.currentLng];
    },
    computedProjectLayers() {
      return (
        this.project?.layers.map(element => {
          if (element.layers) {
            return {
              ...element,
              layers: element.layers.map(layer => {
                return { ...layer, styles: this.getLayerStylesList(layer) };
              }),
            };
          }
          return { ...element, styles: this.getLayerStylesList(element) };
        }) || []
      );
    },
  },
  methods: {
    toggleLayer(id, value) {
      this.$root.$emit('toggleProjectLayerVisibility', { id, value });
    },
  },
};
</script>

<style lang="scss" scoped>
.group-name {
  &::after {
    margin-top: 8px;
    content: '';
    flex: 1;
    height: 2px;
    background-color: map-get($colors, 'secondary');
    margin-left: 8px;
  }
}
::v-deep {
  .v-label {
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block !important;
  }
}
</style>
